// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-action {
  position: absolute;
  top: 0;
  right: 0;
}
.modal-action__close {
  cursor: pointer;
}

.modal-content {
  z-index: 1;
  position: relative;
  display: flex;
  padding: 3% 20px;
  width: 600px;
  height: 70%;
  flex-direction: column;
  border-radius: 16px;
  background: #ffffff;
}

.modal-head {
  padding-left: 20px;
}

.modal-header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  color: #333333;
}

.modal-subheader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  padding: 10px 0 0 0;
}

.modal-body {
  display: flex;
  padding: 30px 20px 10px 20px;
  flex-direction: column;
  overflow-y: auto;
}

th {
  min-height: 50px;
  text-align: left;
  background: rgba(176, 179, 188, 0.1);
}

.modal-table {
  border-collapse: collapse;
  width: 100%;
}

.modal-th {
  padding-left: 10px;
}

.modal-tr {
  line-height: 50px;
  letter-spacing: -0.6px;
  color: #8b8b8b;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.modal-tr__content {
  line-height: 50px;
  border-top: 1px solid #dfdfdf;
}

.modal-td {
  color: #4a4a4a;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding-top: 5px;
}
.modal-td__style1 {
  background: #6f6f6f;
  border-radius: 3px;
  line-height: 140%;
  width: 70%;
  color: white;
  text-align: center;
  padding: 2%;
}

.seemore {
  position: relative;
  text-align: center;
}
.seemore__image {
  width: 100%;
  height: 70px;
}
.seemore__text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4a4a4a;
}

.modal-detail {
  padding: 8px;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-left: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #505054;
  cursor: pointer;
}

.modal-profile {
  display: flex;
  padding-left: 10px;
}
.modal-profile__image {
  margin-right: 10px;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  object-fit: cover;
}
.modal-profile__username {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #505054;
}
.modal-profile__div {
  padding-top: 10px;
}
.modal-profile__time {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #505054;
  padding-left: 10px;
}
.modal-profile__duty {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #505054;
  padding-left: 10px;
}
.modal-profile__other {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #505054;
  padding-left: 10px;
}

.type-of-work-label {
  padding-left: 10px;
}
.type-of-work-label__fixed strong {
  padding: 2px 6px;
  color: #874a3d;
  font-size: 12px;
  border-radius: 4px;
  background: #f9e0da;
}
.type-of-work-label__going-to strong {
  padding: 2px 6px;
  color: #385b7d;
  font-size: 12px;
  border-radius: 4px;
  background: #d5e5f3;
}
.type-of-work-label__selective-work {
  width: 68px;
  height: 22px;
  background: #d6eed9;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #2b6132;
}`, "",{"version":3,"sources":["webpack://./src/common/modal/modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AACJ;AAAI;EACI,eAAA;AAER;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAGA;EACI,gBAAA;EACA,gBAAA;EACA,oCAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;AAEI;EACI,iBAAA;EACA,6BAAA;AAAR;;AAIA;EACI,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGI;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AADR;;AAKA;EACI,kBAAA;EACA,kBAAA;AAFJ;AAII;EACI,WAAA;EACA,YAAA;AAFR;AAKI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAJR;;AAQA;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AANJ;;AASA;EACI,aAAA;EACA,kBAAA;AANJ;AAQI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AANR;AASI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAPR;AAUI;EACI,iBAAA;AARR;AAWI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AATR;AAYI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAVR;AAaI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAXR;;AAeA;EACI,kBAAA;AAZJ;AAgBQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAdZ;AAoBQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAlBZ;AAsBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArBR","sourcesContent":[".modal {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n}\n\n.modal-action {\n    position: absolute;\n    top: 0;\n    right: 0;\n    &__close {\n        cursor: pointer;\n    }\n}\n\n.modal-content {\n    z-index: 1;\n    position: relative;\n    display: flex;\n    padding: 3% 20px;\n    width: 600px;\n    height: 70%;\n    flex-direction: column;\n    border-radius: 16px;\n    background: #ffffff;\n}\n\n.modal-head {\n    padding-left: 20px;\n}\n\n.modal-header {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 26px;\n    line-height: 36px;\n    color: #333333;\n}\n\n.modal-subheader {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #999999;\n    padding: 10px 0 0 0;\n}\n\n.modal-body {\n    display: flex;\n    padding: 30px 20px 10px 20px;\n    flex-direction: column;\n    overflow-y: auto;\n}\n\n// Remove this\nth {\n    min-height: 50px;\n    text-align: left;\n    background: rgba(176, 179, 188, 0.1);\n}\n\n.modal-table {\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.modal-th {\n    padding-left: 10px;\n}\n\n.modal-tr {\n    line-height: 50px;\n    letter-spacing: -0.6px;\n    color: #8b8b8b;\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n\n    &__content {\n        line-height: 50px;\n        border-top: 1px solid #dfdfdf;\n    }\n}\n\n.modal-td {\n    color: #4a4a4a;\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    padding-top: 5px;\n\n    &__style1 {\n        background: #6f6f6f;\n        border-radius: 3px;\n        line-height: 140%;\n        width: 70%;\n        color: white;\n        text-align: center;\n        padding: 2%;\n    }\n}\n\n.seemore {\n    position: relative;\n    text-align: center;\n\n    &__image {\n        width: 100%;\n        height: 70px;\n    }\n\n    &__text {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #4a4a4a;\n    }\n}\n\n.modal-detail {\n    padding: 8px;\n    border: 1px solid #e1e1e1;\n    border-radius: 6px;\n    margin-left: 5px;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: center;\n    color: #505054;\n    cursor: pointer;\n}\n\n.modal-profile {\n    display: flex;\n    padding-left: 10px;\n\n    &__image {\n        margin-right: 10px;\n        border-radius: 50%;\n        height: 25px;\n        width: 25px;\n        object-fit: cover;\n    }\n\n    &__username {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        color: #505054;\n    }\n\n    &__div {\n        padding-top: 10px;\n    }\n\n    &__time {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        color: #505054;\n        padding-left: 10px;\n    }\n\n    &__duty {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        color: #505054;\n        padding-left: 10px;\n    }\n\n    &__other {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        color: #505054;\n        padding-left: 10px;\n    }\n}\n\n.type-of-work-label {\n    padding-left: 10px;\n\n    &__fixed {\n        \n        strong {\n            padding: 2px 6px;\n            color: #874a3d;\n            font-size: 12px;\n            border-radius: 4px;\n            background: #f9e0da;\n        }\n    }\n\n    &__going-to {\n        \n        strong {\n            padding: 2px 6px;\n            color: #385b7d;\n            font-size: 12px;\n            border-radius: 4px;\n            background: #d5e5f3;\n        }\n    }\n\n    &__selective-work {\n        width: 68px;\n        height: 22px;\n        background: #d6eed9;\n        border-radius: 4px;\n        padding: 2px 6px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        color: #2b6132;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
